// extracted by mini-css-extract-plugin
export default {"Spinner":"Spinner_Spinner__-PSeG","lds-roller":"Spinner_lds-roller__fL2ez"};